import { lazy } from 'react'

/**
 * `React.lazy`, plus a way to start the chunk downloading before the route
 * renders.
 *
 * `lazy` only calls its factory the first time React renders the component.
 * Everything behind `RequireAuth` is therefore requested *after* the whole
 * sign-in has resolved — provisioning, then six profile and subscription calls
 * — so the route's chunk and those round trips happen one after the other
 * rather than together. On a slow connection that is the difference between a
 * wait and something that reads as a hang, and the chunks here run to megabytes.
 *
 * `preload()` calls the same factory early. Webpack hands back the request
 * already in flight, so calling it and then rendering costs nothing extra.
 */
export const lazyWithPreload = (factory) => {
  const Component = lazy(factory)

  Component.preload = () =>
    factory().catch(() => {
      // Best-effort warming, and not the visitor's problem: the real render
      // asks for the chunk again and surfaces any failure there, where there is
      // an error boundary to catch it.
    })

  return Component
}
